import React from 'react'

function ListCustomerTableHead() {
    return <thead className="TableHead">
    <tr>
        <th className="colItem">Tên danh sách</th>
        <th className="colItem">Số lượng KH</th>
        <th className="colItem">Số lượng KH đã gọi</th>
        <th className="colItem">Số lượng KH chưa gọi</th>
        <th className="colItem">Ngày tạo</th>
        <th className="colItem">Người tạo</th>
    </tr>
    </thead>
}

export default ListCustomerTableHead
